import { SetCognitoPassword } from '~/pages/auth/onboarding/components/SetCognitoPassword/SetCognitoPassword';

/**
 * Route component for the set password page (/set-password).
 *
 * Renders the password setup flow where users set their password after email verification.
 * This flow is triggered by a link sent to the user's email containing a verification code.
 * Uses Cognito authentication with secure password requirements.
 *
 * @example
 * <SetPasswordRoute />
 *
 * @see SetCognitoPassword (pages/auth/onboarding/components/SetCognitoPassword/SetCognitoPassword)
 */
const SetPasswordRoute = () => {
  return <SetCognitoPassword />;
};

export default SetPasswordRoute;
